module.exports = __webpack_public_path__ + "statics/img/blub.a52c3d59.svg";